import React, { Component } from 'react';
import DataService from 'js/modules/dataservice';
// import constants from 'js/modules/constants';
import storage from 'js/modules/persist';
import DataServiceCatcher from 'js/components/global/DataServiceCatcher';

class ContinueButton extends Component {

  state = {
    step1: {},
  };

  setAction = () => {

    return () => {

      if (this.state.step1.message === 'The infant will become a child at the time of travel. We have updated the infant to child.') {

        return this.props.updateGuests();
      }

      return null;
    };
  }

  fetchVacation = async() => {

    const field = this.props.fields();
    const guestInfo = this.props.guestInfo();
    const { submitVacation, toggleLoader, setVacationResponse } = this.props;
    const errors = submitVacation();

    if (errors === 0) {

      toggleLoader(true);

      const step1 = await DataService.processVacation(field, guestInfo);

      setVacationResponse(step1);

      this.setState({step1});

      if(step1.code === 1) {

        if (storage.get('salesConversion').code === 1) {
          storage.clearObj('salesConversion');
        }
        window.location.href = `/room/?subSessionId=${encodeURIComponent(window._app.page.subSessionId)}`;

        return;
      }

      toggleLoader(false);
    }
  }

  render() {
    const { cleanVacationResponse = null } = this.props;
    const { vacationResponse = {} } = this.props.contextState;
    let hasInvalidFields = false;

    if (
      vacationResponse.content &&
      vacationResponse.content.hasOwnProperty('invalidFields')
    ) {
      hasInvalidFields = true;
    }

    return(
      <DataServiceCatcher
        data={vacationResponse}
        disabledButton={vacationResponse.message === 'Please select all required information.' || hasInvalidFields}
        continueAction={this.setAction()}
        cleanState={cleanVacationResponse}
      >
        <div className="sm-12 row center-sm">
          <button className="sm-11 md-5 lg-4 btn-primary step1-continue" onClick={this.fetchVacation}>CONTINUE</button>
        </div>
      </DataServiceCatcher>
    );
  }
}

export default ContinueButton;



// WEBPACK FOOTER //
// ./js/components/step1/ContinueButton.js